<template>
  <div id="loader-wrapper"><div id="loader"></div></div>
</template>

<script>
import Vue from "vue";

export default Vue.component("VLoaderEnvelope", {});
</script>

<style lang="scss" scoped>
#loader-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 9998;
}

#loader {
  width: 100px;
  height: 50px;
  border-radius: 100%;
  perspective: 120px;

  &:before {
    content: "";
    position: absolute;
    left: 10px;
    border-radius: 4px;
    top: 0;
    width: 80px;
    height: 50px;
    background-color: $primary-color;
    animation: flip 1.5s infinite;
  }

  &:after {
    content: "";
    position: absolute;
    left: 12px;
    top: 3px;
    animation: flip2 1.5s infinite;
    border: 38px solid transparent;
    border-top: 25px solid white;
  }
}

@keyframes flip {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotateY(180deg);
    background-color: $secondary-color;
  }
  100% {
    transform: rotateX(180deg) rotateX(180deg);
    background-color: $tertiary-color;
  }
}

@keyframes flip2 {
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(180deg) rotateY(180deg);
  }
}
</style>
